'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// polyfill webpack require.ensure
if (typeof require.ensure !== 'function') require.ensure = function (deps, cbFn) {
  return cbFn(require);
};

exports.default = function () {
  return {
    path: 'explore',

    getIndexRoute: function getIndexRoute(location, callback) {
      require.ensure([], function (require) {
        callback(null, { component: require('containers/Explore/Explore').Explore });
      }, 'explore');
    },

    getChildRoutes: function getChildRoutes(location, callback) {
      require.ensure([], function (require) {
        callback(null, [{ path: ':hash', component: require('containers/Explore/Explore').Explore }]);
      }, 'explore');
    }
  };
};